module.exports = __webpack_public_path__ + "static/media/ConnectedBoxes.acef9693.svg";